export default {
      id: "close-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "icons.svg#close",
      toString: function () {
        return this.url;
      }
    }